




































import { Component, Prop, Vue } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { InputInterface } from '../types/Exa_Input'

@Component({
    components: {
        FontAwesomeIcon
    }
})
export default class InputChoixMultiple extends Vue {
    @Prop() private libelle!: string
    @Prop() private description!: string
    @Prop() private value!: Array<any>
    @Prop() private data!: { options: Array<{ value: number; libelle: string; ordre: number }> }
    @Prop() private ident!: any
    @Prop() private requis!: boolean
    @Prop() private disabled!: boolean
    @Prop() mode_lecture!: boolean
    @Prop() condition!: InputInterface
    @Prop({ default: false }) check_validation!: boolean

    /** 
     * isChecked 
     * Vérifie si la valeur spécifiée est incluse dans la liste des valeurs actuelles. 
     * @param {any} val - La valeur à vérifier. 
     * @returns {boolean} - True si la valeur est incluse, sinon false. 
     */
    isChecked (val: any) {
        if (this.value && this.value instanceof Array) {
            return this.value.find((valu: any) => Number(val) === Number(valu)) !== undefined
        } else {
            return false
        }
    }

    /**
     * getOptionLibelle
     * Récupère le libellé de l'option correspondant à une valeur donnée.
     * @param option_value La valeur de l'option dont on souhaite obtenir le libellé.
     * @returns Le libellé de l'option correspondant à la valeur donnée. Si aucun libellé n'est trouvé, la valeur d'option est retournée.
     */
    getOptionLibelle(option_value: any) {
        let retour = ''
        for (let j = 0; j < option_value.length; j++) {
            for (let i = 0; i < this.data.options.length; i++) {
                if (String(this.data.options[i].value) === String(option_value[j])) {
                    if (retour !== '') {
                        retour += ', '
                    }
                    retour += this.data.options[i].libelle
                }
            }
        }
        return retour
    }


    /** 
     * inputHandler 
     * Gère les modifications de saisie des cases à cocher en émettant un événement avec les valeurs sélectionnées. 
     * @param {None} - Aucun paramètre requis. 
     */
    inputHandler() {
        const cbs: any = this.$refs['cb_' + this.ident]
        const vals = []
        for (let i =  0; i < cbs.length; i++) {
            if (cbs[i].checked)             {
                vals.push(cbs[i].value)
            }
        }
        this.$emit('input', { ident: this.ident, value: vals })
    }
}
